import { isConfigReport } from 'reporting-data/tsTypes/reportTypes';
import { REPORT_PRESET_TABS } from './reportPresetConstants';
import OriginalReportPresetPill, { isReportValidForOriginalReportPreset } from './OriginalReportPresetPill';
import AIReportRemixPills from './ai-report-remix/AIReportRemixPills';
export const REPORT_PRESETS_CONFIG = {
  [REPORT_PRESET_TABS.DEFAULT]: {
    component: OriginalReportPresetPill,
    isReportValid: isReportValidForOriginalReportPreset
  },
  [REPORT_PRESET_TABS.AI_REMIX]: {
    component: AIReportRemixPills,
    isReportValid: isConfigReport
  }
};